module.exports = __webpack_public_path__ + "img/left1.20833d64.svg";